import React, { useEffect, useState, useRef } from 'react';
import { useGameContext } from '../GameContext';

import './controls.css';

import betIncrease from './assets/bet_increase.mp3';
import betDecrease from './assets/bet_decrease.mp3';
import smallWinSound from './assets/small_win.mp3'


function Controls() {
    const { gameState, updateState, winAmount } = useGameContext();


    //bet
    const betAmount = gameState.currentBet;
    const currentBal = gameState.currentBalance;
    const bets = gameState.bets;
    const isMinBet = betAmount <= bets[0];
    const isMaxBet = betAmount >= bets[bets.length - 1];

    const increaseBet = () => {
        const currentBetIndex = bets.indexOf(betAmount);
        const newBet = bets[Math.min(currentBetIndex + 1, bets.length - 1)];
        updateState('currentBet', newBet);
        const audio = new Audio(betIncrease);
        audio.play();
    };

    const decreaseBet = () => {
        const currentBetIndex = bets.indexOf(betAmount);
        const newBet = bets[Math.max(currentBetIndex - 1, 0)];
        updateState('currentBet', newBet);
        const audio = new Audio(betDecrease);
        audio.play();
    };


    //spin
    const { startSpin, isSpinning } = useGameContext();
    const spin = () => {
        if(!isSpinning && (betAmount <= currentBal)){
            startSpin();
        }
    };

    

    const canSpin = !isSpinning && betAmount <= currentBal;


    //info pane
    const [infoPaneVisible, setInfoPaneVisible] = useState(false);
    const infoPaneRef = useRef(null);
    const showInfoPane = () => {
        setInfoPaneVisible(true);
    }
    const hideInfoPane = () => {
        setInfoPaneVisible(false);
    }

    const handleClickOutside = (event) => {
        if(infoPaneRef.current && !infoPaneRef.current.contains(event.target)){
            setInfoPaneVisible(false);
        }
    };
    

    useEffect(() => {
        if(infoPaneVisible){document.addEventListener('mousedown', handleClickOutside);}
        return () => {document.removeEventListener('mousedown', handleClickOutside);}
    }, [infoPaneVisible]);



    //extra money
    const [extraMoneyBtnVisible, setExtraMoneyBtnVisible] = useState(false);
    useEffect(() => {
        if(!isSpinning && currentBal < 1){
            setExtraMoneyBtnVisible(true);
        }
    }, [startSpin, isSpinning]);

    const addExtraMoney = () => {
        const sound = new Audio(smallWinSound);
        sound.play();
        setExtraMoneyBtnVisible(false);
        updateState('currentBalance', 100);
    }
    





    return (
        <div className='controls-pane'>
            <div className='info-btn' onClick={ showInfoPane }>
                <h2>&#128712;</h2>
            </div>
            <div className='balance'>
                <h1>CURRENT BALANCE</h1>
                <h2>{gameState.currentBalance}</h2>
            </div>
            <div className='bet-controls'>
                <div className={`btn minus ${(isMinBet||isSpinning) ? 'disabled' : ''}`} onClick={!(isMinBet||isSpinning) ? decreaseBet : undefined}>
                    <h1>-</h1>
                </div>
                <div className='amount'>
                    <h1>TOTAL BET</h1>
                    <h2>{betAmount}</h2>
                </div>
                <div className={`btn plus ${(isMaxBet||isSpinning) ? 'disabled' : ''}`} onClick={!(isMaxBet||isSpinning) ? increaseBet : undefined}>
                    <h1>+</h1>
                </div>
            </div>
            <div className='win-pane'>
                <h1>TOTAL WIN</h1>
                <h2 className={(winAmount>0) ? `flash` : ``}>{winAmount}</h2>
            </div>
            <div className={`extra-money-btn ${extraMoneyBtnVisible ? 'visible' : ''}`} onClick={ addExtraMoney }>
                <h2>+$</h2>
            </div>
            <div className={`spin-btn ${!canSpin ? 'disabled' : ''}`} onClick={ spin }>
                <h1>SPIN</h1>
            </div>

            <div ref={infoPaneRef} className={`info-pane ${infoPaneVisible ? 'visible' : ''}`}>
                <h1>Lexus Pokies</h1>
                <h2>3x Lexus Badge = Feature (50x bet)</h2>
                <h2>3x F Badge = 12x bet</h2>
                <h2>5x Lexus Key = 4x bet</h2>
                <h2 className='close' onClick={ hideInfoPane }>Close</h2>
            </div>
        </div>
    );
}

export default Controls;
